import React,{useState, useEffect, useRef} from 'react';
import { COOKIESPREFIX } from '../config';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { getRedeemAvailibity, getUserInfo } from '../services/service';
import {postSelectCata} from '../services/service'
import Nav from '../components/Nav'
import { useLayoutEffect } from 'react';
//screens
function App({}) {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies([`@${COOKIESPREFIX}_token`]);
  const [selectedType, setSelectedtype] = useState(undefined)
  const [isNavOpen, setIsNavOpen] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const [gameData,setGameData]= useState({})
  const [available,setavailable]= useState({})
  async function getGameState(){
    const userToken = cookies[`@${COOKIESPREFIX}_token`]
    const res = await getUserInfo(userToken)
    if(res.errno) return
    const gameInfo = res.data?.data
    setGameData(res.data)
    if(gameInfo?.category) return navigate('/gamemap')
  }
  async function getAvailability(){
    const userToken = cookies[`@${COOKIESPREFIX}_token`]
    if(userToken){
      let res = await getRedeemAvailibity(userToken)
      //ff0000000000000000000001 fasion
      //ff0000000000000000000002 sport
      //ff0000000000000000000003 family
      //ff0000000000000000000001 beauty
      console.log(res.result)
      if(res.result){
        let fasion= res.result?.rewards?.['ff0000000000000000000001']||{}
        let sport= res.result?.rewards?.['ff0000000000000000000002']||{}
        let family= res.result?.rewards?.['ff0000000000000000000003']||{}
        let beauty= res.result?.rewards?.['ff0000000000000000000004']||{}
        setavailable({
          fasion: fasion?.count<fasion?.max,
          sport: sport?.count<sport?.max,
          family: family?.count<family?.max,
          beauty: beauty?.count<beauty?.max
        })
      }
    }
  }
  useEffect(() => {
    if(!cookies[`@${COOKIESPREFIX}_token`]) return navigate('/')
    getGameState()
    getAvailability()
  },[])

  async function handleUserPick(){
    if(selectedType === undefined) return;
    const res = await postSelectCata(cookies[`@${COOKIESPREFIX}_token`], selectedType)
    if(res.errno) return;
    navigate('/gamemap')
  }

  const topRef= useRef(null)
  useLayoutEffect(()=>{
      setTimeout(()=>{
        if(topRef?.current)
         topRef.current.scrollIntoView();
      },500)
  },[])

  const isAllUnavailable =()=>{
    return (!available.fasion)&&(!available.beauty)&&(!available.sport)&&(!available.family)
  }

  return (
    <div className="flex flex-col items-center w-[100%] h-[100%] overflow-y-auto">
      <div ref={topRef}/>
      <div className='relative w-full'>
        <div onClick={() => setIsNavOpen(true)} className='w-[9%] h-[3%] top-[10%] left-[84%] absolute flex flex-col items-center justify-between' style={{zIndex:99}}>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
        </div>
        <Nav gameData={gameData} closeNav={() => setIsNavOpen(false)} isNavOpen={isNavOpen} />
        {/* <img src={'/images/typebg.jpg'} className='w-full'></img> */}
        <div style={{ position: 'relative', top:0, left:0 }}>
            {/* <video style={{ position: 'absolute', top: 0, left: 0, zIndex: 0 }} loop={true} muted={true} controls={false} autoPlay playsInline src='/bgloopv2.mp4' /> */}
            <img onLoad={() => setIsLoaded(true)} src={isAllUnavailable()?'/images/newpick_.png':'/images/newpick.png'} className='w-full' style={{ position: 'relative', zIndex: 10, top:0 }} alt="Background Image" />
        </div>
        {isLoaded&&isAllUnavailable()&&<div className='absolute top-0 left-0 w-full h-full flex justify-center items-center font-bold text-[24px] pb-[64px] text-center'>
          是日禮物換罄，<br/>
          請明天踴躍參與！
        </div>}
        {isLoaded && !isAllUnavailable() && <div style={{zIndex:97}} className='absolute top-0 left-0 w-full h-full'>
          <div onClick={() => {if(available?.beauty)setSelectedtype('beauty')}} className='flex flex-col items-center w-[40%] h-[19%] absolute left-[7%] top-[28%]'>
            <div className='border rounded-xl border-[2px]' style={{borderColor: selectedType === 'beauty' ? '#b4a050' : '#FFFFFF',opacity: available?.beauty?1:.3}}>
              {selectedType === 'beauty' ? <img src={'/images/btn/icon1select.png'} className=''></img>:  <img src={'/images/btn/icon_1.png'} className=''></img>}
            </div>
            <div className='text-[18px] text-[#3374bf]' style={{opacity: available?.beauty?1:.3}}>美妝達人</div>
            {available?.beauty||<img src='/images/btn/unavailable.png' className='absolute top-[30%] w-[75%]'/>}
          </div>
          <div onClick={() => {if(available?.fasion)setSelectedtype('fasion')}} className='flex flex-col items-center w-[40%] h-[19%] absolute left-[52%] top-[28%]'>
            <div className='border rounded-xl border-[2px]' style={{borderColor: selectedType === 'fasion' ? '#b4a050' : '#FFFFFF',opacity: available?.fasion?1:.3}}>
              {selectedType === 'fasion' ? <img src={'/images/btn/icon2select.png'} className=''></img>:  <img src={'/images/btn/icon_2.png'} className=''></img>}
            </div>
            <div className='text-[18px] text-[#3374bf]' style={{opacity: available?.fasion?1:.3}}>時尚達人</div>
            {available?.fasion||<img src='/images/btn/unavailable.png' className='absolute top-[30%] w-[75%]'/>}
          </div>
          <div onClick={() => {if(available?.sport)setSelectedtype('sport')}} className='flex flex-col items-center w-[40%] h-[19%] absolute left-[7%] top-[52%]'>
            <div className='border rounded-xl border-[2px]' style={{borderColor: selectedType === 'sport' ? '#b4a050' : '#FFFFFF',opacity: available?.sport?1:.3}}>
              {selectedType === 'sport' ? <img src={'/images/btn/icon3select.png'} className=''></img>:  <img src={'/images/btn/icon_3.png'} className=''></img>}
            </div>
            <div className='text-[18px] text-[#3374bf]' style={{opacity: available?.sport?1:.3}}>運動塑身達人</div>
            {available?.sport||<img src='/images/btn/unavailable.png' className='absolute top-[30%] w-[75%]'/>}
          </div>
          <div onClick={() => {if(available?.family)setSelectedtype('family')}} className='relative flex flex-col items-center w-[40%] h-[19%] absolute left-[52%] top-[52%]'>
            <div className='border rounded-xl border-[2px]' style={{borderColor: selectedType === 'family' ? '#b4a050' : '#FFFFFF',opacity: available?.family?1:.3}}>
              {selectedType === 'family' ? <img src={'/images/btn/icon4select.png'} className=''></img>:  <img src={'/images/btn/icon_4.png'} className=''></img>}
            </div>
            <div className='text-[18px] text-[#3374bf]' style={{opacity: available?.family?1:.3}}>家居及育兒達人</div>

            {available?.family||<img src='/images/btn/unavailable.png' className='absolute top-[30%] w-[75%]'/>}
          </div>
          {/* <div className='absolute border border-black w-[37%] h-[5%] absolute left-[32%] top-[76%]' onClick={handleUserPick}></div> */}
          <div type='submit' value={''} className='absolute w-[100%] h-[5%] absolute left-[0%] top-[76%] flex flex-row items-center justify-center'>
            {(selectedType) ? <img onClick={handleUserPick} src='/images/btn/nextstep.png' className='w-[50%]' style={{height:undefined, aspectRatio:370/156}} /> : <img src='/images/btn/greyconfirm.png' className='w-[50%]' style={{height:undefined, aspectRatio:370/156}}/>}
          </div>
        </div>}
      </div>
    </div>
  );
}

export default App;